import { render, staticRenderFns } from "./messageGroupView.vue?vue&type=template&id=e4af1d46"
import script from "./messageGroupView.vue?vue&type=script&lang=js"
export * from "./messageGroupView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports